import { Modal, ModalFuncProps } from 'antd';

export const showConfirm = (args: ModalFuncProps) => new Promise<boolean>((resolve) => {
  Modal.confirm({
    ...args,
    onOk: () => {
      if (args.onOk) {
        args.onOk();
      }
      resolve(true);
    },
    onCancel: () => {
      if (args.onCancel) {
        args.onCancel();
      }
      resolve(false);
    },
  });
});

export const showSuccess = (args: ModalFuncProps) => new Promise<boolean>((resolve) => {
  Modal.success({
    ...args,
    onOk: () => {
      resolve(true);
    },
  });
});
